import { getStorage, ref, getDownloadURL, uploadString } from 'firebase/storage';
import { Firebase_App } from './firebase';

const storage = getStorage(Firebase_App);

export async function loadFileFromStorage(path: string) {
  try {
    const storageRef = ref(storage, path);
    const downloadURL = await getDownloadURL(storageRef);
    const response = await fetch(downloadURL);
    return await response.text()  
  } catch (error) {    
    if (error.code === 'storage/object-not-found') {
      return null;
    } else {
      throw error;
    }
  }
}

export async function saveFileToStorage(path: string, content: string) {
  const storageRef = ref(storage, path);
  await uploadString(storageRef, content);
}
